import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { useApi } from "~hooks/apiHooks/useApi";
import type { RoleResponse } from "~types/role";

type TransformFn<T> = (data: RoleResponse) => T;

export const useFetchFixtureRoles = <TTransformedData = RoleResponse>(
  fixtureId: string,
  params: Record<string, string>,
  transformFn: TransformFn<TTransformedData> = (data) => data as unknown as TTransformedData,
  additionalQueryKeys: string[] = [],
  options: Omit<UseQueryOptions<TTransformedData>, "queryKey" | "queryFn"> = {},
) => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  if (!organizationId || !sport) {
    throw new Error(`OrganizationId, sport or seasonId not found in route params. organizationId: ${organizationId}, sport: ${sport}`);
  }

  return useQuery({
    queryKey: ["roles", sport, organizationId, ...additionalQueryKeys, JSON.stringify(params)],
    queryFn: () =>
      request<RoleResponse>(`${sport}/o/${organizationId}/fixtures/${fixtureId}/roles?${new URLSearchParams(params)}`).then(transformFn),
    ...options,
  });
};
